// File: src/pages/buyer/AddProduct/sections/FAQs.jsx
import React from "react";
import { useFormContext } from "react-hook-form";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { FaLightbulb, FaPlus, FaTrash } from "react-icons/fa";

const FAQs = ({ onGenerateAi, aiLoading }) => {
  const { watch, setValue } = useFormContext();
  const faqs = watch("faqs") || [];

  const addFaq = () =>
    setValue("faqs", [...faqs, { question: "", answer: "" }]);
  const removeFaq = (i) =>
    setValue(
      "faqs",
      faqs.filter((_, idx) => idx !== i)
    );
  const updateFaq = (i, key, val) => {
    const copy = [...faqs];
    copy[i] = { ...copy[i], [key]: val };
    setValue("faqs", copy, { shouldValidate: true });
  };

  return (
    <div className="border rounded p-4 mb-4 bg-white">
      <h5 className="fw-semibold mb-3">Frequently Asked Questions</h5>

      {/* Action Buttons */}
      <div className="d-flex gap-2 mb-4">
        <Button variant="outline-secondary" onClick={addFaq}>
          <span className="d-inline-flex align-items-center gap-1">
            <FaPlus />
            <span>Add New</span>
          </span>
        </Button>

        <Button
          variant="outline-secondary"
          size="sm"
          disabled={aiLoading}
          onClick={onGenerateAi}
        >
          {aiLoading ? (
            <Spinner size="sm" />
          ) : (
            <>
              <span className="d-inline-flex align-items-center gap-1">
                <FaLightbulb />
                <span>Generate with AI</span>
              </span>
            </>
          )}
        </Button>
      </div>

      {/* FAQ List */}
      {faqs.length > 0 ? (
        faqs.map((faq, index) => (
          <Row className="g-3 align-items-center mb-3" key={index}>
            <Col md={5}>
              <Form.Control
                placeholder="Enter question"
                value={faq.question}
                onChange={(e) => updateFaq(index, "question", e.target.value)}
              />
            </Col>

            <Col md={5}>
              <Form.Control
                placeholder="Enter answer"
                value={faq.answer}
                onChange={(e) => updateFaq(index, "answer", e.target.value)}
              />
            </Col>

            <Col md={2} className="text-end">
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => removeFaq(index)}
                title="Remove FAQ"
              >
                <FaTrash />
              </Button>
            </Col>
          </Row>
        ))
      ) : (
        <p className="text-muted">No FAQs added yet.</p>
      )}
    </div>
  );
};

export default React.memo(FAQs);
